import { SpsTableL0Base } from "./l0-base";
import { AfterContentInit, EventEmitter, OnChanges, Input, Output, SimpleChanges } from "@angular/core";
import { SortedColumn } from "@spscommerce/ds-shared";
import { onNextTick } from "@spscommerce/utils";
import autobind from "autobind-decorator";

export class SpsTableL1Sorting extends SpsTableL0Base implements AfterContentInit, OnChanges {
    static readonly props = {
        ...SpsTableL0Base.props,
        sort: "Array<SortedColumn>",
        sortChange: { event: true, type: "Array<SortedColumn>" },
    };

    @Input() sort: SortedColumn[] = [];
    @Output() sortChange = new EventEmitter<SortedColumn[]>();

    ngOnChanges(changes: SimpleChanges) {
        if (changes.sort && !changes.sort.firstChange) {
            onNextTick(this.updateSortingDisplay);
        }
    }

    ngAfterContentInit() {
        for (const header of this.headers) {
            header.sortFlipped.subscribe(() => {
                this.sort = [{ key: header.sortKey, direction: header.sort }];
                this.sortChange.emit(this.sort);
                this.updateSortingDisplay();
            });

        }
        onNextTick(this.updateSortingDisplay);
    }

    @autobind
    updateSortingDisplay() {
        if (this.headers) {
            this.sort = this.sort || [];
            // Eventually there could be more items in this.sort when we get to
            // multi-column sorting support. For now, it's just the one.
            const sortedColumn = this.sort[0];

            for (const header of this.headers) {
                if (sortedColumn && header.sortKey === sortedColumn.key) {
                    header.sort = sortedColumn.direction;
                } else {
                    header.sort = undefined;
                }
            }
        }
    }
}
